import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/app/(darkHeader)/voiceover/VoiceoverContainer.tsx");
